module.exports = __webpack_public_path__ + "static/dinosaur-97608654dee19569778245c0dad9baf7.svg";